import { DealDetailsFormValues, SelectData } from "../../models";

export enum DealJourneyNavigatorPages {
  DETAILS = "Details",
  ASSOCIATIONS = "Associations",
  STRUCTURE = "Structure",
  WORKFLOW = "Workflow",
}

export const defaultFormValues: DealDetailsFormValues = {
  conversionProbability: undefined,
  dealName: undefined,
  dealPipelineUuid: undefined,
  dealWorkflowStageDates: {},
  dealWorkflowTemplateUuid: undefined,
  description: undefined,
  dealLeadUuid: undefined,
  dealTeamUuids: undefined,
  dealSource: undefined,
  estimatedFees: undefined,
  introductionDate: undefined,
  targetCloseDate: undefined,
  projectedDpi: undefined,
  associations: [],
  selectedInvestedInto: null,
  companyDraft: null,
  createdCompanyDrafts: [],
  projectDrafts: [],
  landholdingDrafts: [],
  structureInvestments: [],
};

export const RETURNS_PERIOD_UNIT_SELECT_DATA: SelectData = [
  { key: "Weekly", value: "Weekly" },
  { key: "Monthly", value: "Monthly" },
  { key: "Quarterly", value: "Quarterly" },
  { key: "Annually", value: "Annually" },
  { key: "Exit", value: "Exit" },
];
